import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import TenantAuditDetail from './TenantAuditDetail';
import { Container } from 'reactstrap';

const TenantAudit = () => {
    const { t } = useTranslation();
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={t('Audit')} title={t('Tenant Audit Detail')} mainTitle={t('Tenant Audit Detail')} />
                <Container fluid={true}>
                    <TenantAuditDetail />
                </Container>
            </Fragment>
        </UL>
    )
}

export default TenantAudit